import React, { useEffect } from 'react';
import MoverService from '../../services/MoverService.js';
import AuthenticatedComponent from '../AuthenticatedComponent';
import { connect } from 'react-redux'
import MoverComponent from './subcomponents/MoverComponent.jsx';
import CreateMoverComponent from './subcomponents/CreateMoverComponent.jsx';
import ApartmentService from '../../services/ApartmentService.js';

function Movers(props) {

  const requestApartments = () => {
    if(props._apartments.length === 0)
    {
      ApartmentService.getApartments();
    }
  };

  const requestMovers = () => {
    if(props._movers.length === 0)
    {
      MoverService.get();
    }
  };

  useEffect(() => {
    requestMovers();
    requestApartments();
  }, []);

  let moverScaffold = {
    buyer_name: '',
    takeover_date: null,
    seller_email: '',
    seller_postcode: '',
    seller_address: '',
    seller_suburb: '',
    seller_name: '',
    apartment_id: null
  };

  let movers = null;
  if (props._movers) {
    movers = props._movers.map((mover) => {
      return <MoverComponent key={mover.id} mover={mover}></MoverComponent>;
    });
  }

  return (
    <React.Fragment>
      <div className="container">
        <div className="col-md">
          <table id="apartmentsTable" className="table table-responsive table-hover table-striped"><thead>

            <tr>
              <th style={{ textAlign: "center" }}>Overtagelsesdato</th>
              <th style={{ textAlign: "center" }}>Andels nr.</th>
              <th className='textAlignLeft'>Sælgers navn</th>
              <th className='textAlignLeft'>Sælgers addresse</th>
              <th className='textAlignLeft'>Sælgers email</th>
              <th className='textAlignLeft'>Købers navn</th>
            </tr>
          </thead>

            {movers}
            <CreateMoverComponent mover={moverScaffold}></CreateMoverComponent>
          </table>
        </div>
      </div>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  const { _movers } = state.mover;
  const { _apartments } = state.apartments;
  return { _movers, _apartments };
}



export default AuthenticatedComponent(connect(mapStateToProps)(Movers))